import { Box,Spinner } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { InputGroup } from "react-bootstrap";

import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { FaEye } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncPdfPreviewData } from "redux/userSlice";
import * as pdfjsLib from "pdfjs-dist/build/pdf";

import {  GlobalWorkerOptions } from "pdfjs-dist";

GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

console.log('what is process.env.BASE_URL', process.env?.REACT_APP_BASE_URL)

const InvoiceComponent = ({
  getInvoice,
  handleDelete,
  selectedFile,
  handleDeleteOnEdit,
  isEditing,
  addNewInvoiceOnEdit,
  submitInvRemark,
  handleAddInvoiceRemarks,
  role
}) => {
  const [editPan, setEditPan] = useState(false);
  const [remark, setRemark] = useState(selectedFile.remark || "");
  const fileInputRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false)


  const { addToast } = useToasts();
  const dispatch = useDispatch();
  
  const validatePDF = async (file) => {
    try {
      if (typeof file.arrayBuffer !== "function") {
        addToast("Invalid file format.", { appearance: "error" });
        return false;
      }
  
      const pdfData = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
      const numPages = pdf.numPages;
  
      let fullText = "";
  
      for (let i = 1; i <= numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const text = textContent.items.map(item => item.str).join(' ');
        fullText += text + " ";
      }
  
      const looseScriptRegex = /<\s*script\b[^>]*>(.*?)<\s*\/\s*script\s*>/gis;
      const looseHtmlTagRegex = /<\s*\/?\s*\w+\s*[^>]*>/gi;

      if (looseScriptRegex.test(fullText)) {
        addToast("Rejected: Invalid file content.", { appearance: "error" });
        return false;
      }
  
      if (looseHtmlTagRegex.test(fullText)) {
        addToast("Rejected: Rejected: Invalid file content", { appearance: "error" });
        return false;
      }
  
      return true;
  
    } catch (error) {
      // addToast("Failed to validate PDF. Please try again.", { appearance: "error" });
      return true;
    }
  };
  
  
  const handleFileChange = async(e) => {
    if (e.target.files) {
      
      if (e.target.files[0]?.size < 2 * 1024 * 1024) {
        const isValid = await validatePDF(e.target.files[0]);
        if(isValid){
          if (isEditing) {
            addNewInvoiceOnEdit(e.target.files[0]);
          } else {
            getInvoice(e.target.files[0]);
          }
        }
        else {
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        }
       
      } else {
        addToast("Please attach file less then 2Mb", { appearance: "warning" });
      }
    }
  };

  
  const handlePreview = async (key, spId) => {
    setIsLoading(true)

    try {
      const data = { key:selectedFile?.Key, spId:selectedFile?.spId };
      const response = await dispatch(fetchAsyncPdfPreviewData(data)).unwrap();
      const blob = new Blob([response], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(blob);
      window.open(pdfUrl, '_blank'); 
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      addToast(`Error fetching PDF preview, file not found`, { appearance: "error" });
    }
  };




  return (
    <>
      <div>
        <Row className="mb-3">
          {selectedFile.Key ? (
            <>
              <Col >
              <Box display="flex" className="input-box">
                <Form.Label>Invoice Attached</Form.Label>
                <Box display="flex" >
                <InputGroup>
                <Form.Control
                  type="input"
                
                  className="invoice-input" 
                  name="invoice"
                  placeholder="PDF"
                  disabled
                  accept="application/pdf"
                  value={selectedFile.Key?.split("/").at(-1)}
                  title={selectedFile.Key?.split("/").at(-1)}
                />
                <InputGroup.Text>
                {isLoading ?
                  <Spinner size="sm"/>
                :

                 <FaEye 
                color="#000d55"
                cursor="pointer"
                
                  size={20}
                  onClick={handlePreview}
                />
                }
                </InputGroup.Text>
                </InputGroup>
                </Box>
               
                </Box>
              </Col>
              {isEditing && (
                <Col className="align-items-center" >
                  <Box display="flex" className="input-box mt-0">

                  <Form.Label>Invoice Remark</Form.Label>
                  
                  <Box display="flex" alignItems="center" width={240}>
                    <InputGroup>
                    <Form.Control
                      type="text"
                      name="panNumber"
                      className="invoice-input"
                      placeholder="Remark"
                      disabled={!editPan}
                      onChange={(e) => setRemark(e.target.value)}
                      value={remark}
                    />
                    <InputGroup.Text>
                    {!editPan ? (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                        alt="edit"
                        className="edit-button panEdit"
                        onClick={() => {
                          setEditPan(true);
                        }}
                      />
                    ) : (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                        alt="right"
                        className="edit-button panEdit"
                        onClick={() => {
                          submitInvRemark(remark);
                          setEditPan(false);
                        }}
                      />
                    )}
                    </InputGroup.Text>
                    
                      </InputGroup>
                    {(role === "Admin" || role === "SuperAdmin") && (
                    
                      <FaTrash
                        style={{
                          fontSize: "16px",
                          color: "red",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDeleteOnEdit(selectedFile.Key, selectedFile?.spId)}
                      />
                  )}
                  </Box>
                  </Box>

                </Col>
              )}
              {/* <Col className="d-flex align-items-center">
              
              </Col> */}
            </>
          ) : (
            <>
              <Col>
              <Box display="flex" className="input-box" >

                <Form.Label>
                  Invoice (<span>*</span>.pdf)
                </Form.Label>

                <Form.Control
                  type="file"
                  name="invoice"
                  className=""
                  placeholder="PDF"
                  ref={fileInputRef}
                  onChange={(e) => handleFileChange(e)}
                  accept="application/pdf"
                />
                </Box>
              </Col>
              {selectedFile?.file ?
              <Col className="align-items-center" >
                  <Box display="flex" className="input-box mt-0">

                  <Form.Label>Invoice Remark</Form.Label>
                  
                  <Box display="flex" alignItems="center" width={240}>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="panNumber"
                      className="invoice-input"

                      placeholder="Remark"
                      disabled={!editPan}
                      onChange={(e) => setRemark(e.target.value)}
                      value={remark}
                    />
                    <InputGroup.Text>
                    {!editPan ? (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/650/650143.png"
                        alt="edit"
                        className="edit-button panEdit"
                        onClick={() => {
                          setEditPan(true);
                        }}
                      />
                    ) : (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/8832/8832108.png"
                        alt="right"
                        className="edit-button panEdit"
                        onClick={() => {
                          handleAddInvoiceRemarks(remark);
                          setEditPan(false);
                        }}
                      />
                    )}
                    </InputGroup.Text>
                    
                      </InputGroup>
                      <FaTrash
                        style={{
                          fontSize: "16px",
                          color: "red",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDelete()}
                      />
                  </Box>
                  </Box>

                </Col>
                :
                <Col></Col>
              }
             
            </>
          )}
           {/* PDF Preview Modal */}
    
        </Row>
      </div>
     
    </>
  );
};

export default InvoiceComponent;
